import RepProduct from "./rep-products";

export default RepProduct;